import Button, { Props } from './Button'
import LoadingButton from './LoadingButton'

export default Button
export { LoadingButton }
export type ButtonProps = Props
